import { Default, Detail, List,  Create } from "./views";



const Module = {
    name: "services",
    defaultRoutePath: "/cars/service",
    menuItemScope: "fleet",
    menuItemName: "services",

    routes: [
        {
            path: "/cars/service",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
